import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
const IVButton = React.forwardRef((props, ref) => {
    const { className = '', children, ...args } = props;
    return (_jsx("button", { className: `iv-button iv-transition iv-duration-150 iv-ease-in ${className}`, ref: ref, ...args, children: children }));
});
export default IVButton;
